import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxFull } from '@fortawesome/pro-regular-svg-icons/faBoxFull'
import { isInStorefront } from '../../utils/isInStorefront'

let Icon = () => (
    <div className="flex items-center justify-center w-full py-10">
        <FontAwesomeIcon icon={faBoxFull} size="6x" />
    </div>
)

const PanelsContent = ({
    flipped,
    largePanelImage,
    largePanelImageAlt,
    largePanelImageLink,
    largePanelImageLinkExternal,
    smallPanelImageTop,
    smallPanelImageTopAlt,
    smallPanelImageTopLink,
    smallPanelImageTopLinkExternal,
    smallPanelImageBottom,
    smallPanelImageBottomAlt,
    smallPanelImageBottomLink,
    smallPanelImageBottomLinkExternal,
}) => {
    const inStorefront = isInStorefront()

    return (
        <div>
            <div
                className={`container grid grid-cols-1 gap-[15px] lg:grid-cols-6 lg:gap-[30px] ${
                    flipped ? 'lg:flex-row-reverse' : ''
                }`}
            >
                <a
                    href={largePanelImageLink}
                    className="lg:col-span-4 w-full h-full"
                    {...(!inStorefront && {
                        onClick: e => {
                            e.preventDefault()
                        },
                    })}
                    {...(largePanelImageLinkExternal && {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                    })}
                >
                    <img src={largePanelImage} alt={largePanelImageAlt} className="w-full h-full" />
                </a>
                <div
                    className={`lg:col-span-2 flex flex-col gap-y-[15px] lg:gap-y-[30px] ${
                        flipped ? 'order-first' : ''
                    }`}
                >
                    <a
                        href={smallPanelImageTopLink}
                        className="lg:col-span-4 w-full h-full"
                        {...(!inStorefront && {
                            onClick: e => {
                                e.preventDefault()
                            },
                        })}
                        {...(smallPanelImageTopLinkExternal && {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                        })}
                    >
                        <img
                            src={smallPanelImageTop}
                            alt={smallPanelImageTopAlt}
                            className="w-full h-full"
                        />
                    </a>
                    <a
                        href={smallPanelImageBottomLink}
                        className="lg:col-span-4 w-full h-full"
                        {...(!inStorefront && {
                            onClick: e => {
                                e.preventDefault()
                            },
                        })}
                        {...(smallPanelImageBottomLinkExternal && {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                        })}
                    >
                        <img
                            src={smallPanelImageBottom}
                            alt={smallPanelImageBottomAlt}
                            className="w-full h-full"
                        />
                    </a>
                </div>
            </div>
        </div>
    )
}

const PanelsRenderer = ({ state, ...props }) => {
    return <PanelsContent {...state} {...props} />
}

export default PanelsRenderer
